export default __webpack_public_path__ + "static/media/login_logo.325a7f18.png";